import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Table } from 'antd';

const EntityTab = () => {

const [showExtraEntity, setShowExtraEntity] = useState(false);
const [showMasterShipper, setShowMasterShipper] = useState(false);
const [showCustomBroker, setShowCustomBroker] = useState(false);
const [showSecondNotify, setShowSecondNotify] = useState(false);
const [showThirdNotify, setShowThirdNotify] = useState(false);
const [showTransporter, setShowTransporter] = useState(false);
const [showShipTo, setShowShipTo] = useState(false);
const [showBookingParty, setShowBookingParty] = useState(false);
const [showSeller, setShowSeller] = useState(false);
const [showImporter, setShowImporter] = useState(false);
const [showBuyer, setShowBuyer] = useState(false);
const [showCertifiter, setShowCertifiter] = useState(false);
const columns = [
    { title: "Sr.", dataIndex: "SNo", key: "SNo" },
    { title: "Bill Head", dataIndex: "Name", key: "Name" },
    { title: "Amount", dataIndex: "Alias", key: "Alias" },
    { title: "Amount (INR)", dataIndex: "NVOCC", key: "NVOCC" },
    { title: "Taxable", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "Tax Code	", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "CGST (INR)", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "SGST (INR)", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "CESS (INR)", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "RCM", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "Total Amount (INR)", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "Cost Center", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "Remarks", dataIndex: "HomepageURL", key: "HomepageURL" },
];

const dataSource = [
    {
        key: "1",
    }
];

useEffect(() => {
if (showMasterShipper==true || showCustomBroker == true || showSecondNotify == true || showThirdNotify == true || showTransporter == true ||
showShipTo == true || showBookingParty == true || showSeller == true || showImporter == true || showBuyer == true) {
setShowExtraEntity(true);
} else {
setShowExtraEntity(false);
}
}, [showMasterShipper, showCustomBroker, showSecondNotify, showThirdNotify, showTransporter, showShipTo, showBookingParty, showSeller,
showImporter, showBuyer])

const shipperOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
];

return (
<>
    <form>
        <div className="card">
            <div className="card-body">
            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                            <div className="d-flex justify-content-between mt-3 gap-2">
            <div className="d-flex">
                <input type="checkbox" />
                <label htmlFor="" className='ms-1'>Round Off</label>
            </div>
            <div>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Recalculate
            </button>
            </div>
            </div>
            </div>
        </div>
    </form>
</>
)
}

export default EntityTab